<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">{{ $t('view') }} {{ $t('receipts') }} {{ $t('templates') }}</div>
      <div>
        <!-- <router-link :to="'edit-receipts-template' + rtemp_id" class="btn-blue">{{ $t('edit') }}</router-link> -->
        <router-link
          class="btn-blue"
          to="receipts-template"
        >{{ $t('receipts') }} {{ $t('templates') }} {{ $tc('list', 1) }}</router-link>
      </div>
    </div>

    <div class="all-details-container">
      <div class="row justify-content-center">
        <div v-html="htmlData"></div>
      </div>
    </div>

    <!-- <div class="white-wrapper mt-4">
      <div class="row">
        <div v-if="rtemp_id == 3" class="col-md-12 d-flex justify-content-center">
          <div class="receipt">
            <table>
              <thead>
                <tr>
                  <th colspan="5">
                    <div>CENTURY CINEMAX GARDEN CITY</div>
                    <div>0796 299 982 / 0789 042 901</div>
                    <div>Pin No: P051359115A</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr style="border-bottom: 1px dashed #000000">
                  <td colspan="3">
                    <div class="font-weight-bold">Sales Receipt</div>
                    <div>15/02/20 13:24</div>
                  </td>
                  <td colspan="2" style="vertical-align: bottom;">Transaction No: 462999</td>
                </tr>
                <tr style="border-bottom: 1px dashed #000000">
                  <td>Qty</td>
                  <td>Description</td>
                  <td>Price</td>
                  <td>Tax</td>
                  <td>Total</td>
                </tr>
                <tr>
                  <td colspan="5" style="font-weight: bold;">Tickets</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Tanhaji-2D-Hindi (Screen 1: Gold) 15/02/20 02:30 Hrs</td>
                  <td>300</td>
                  <td>30.00</td>
                  <td>330</td>
                </tr>
                <tr>
                  <td colspan="5" style="font-weight: bold;">Products</td>
                </tr>
                <tr style="border-bottom: 1px dashed #000000">
                  <td>1</td>
                  <td>Large Coke</td>
                  <td>100</td>
                  <td>0.00</td>
                  <td>100</td>
                </tr>
                <tr>
                  <td colspan="5" style="text-align: right">Amount Due: INR 300.00</td>
                </tr>
                <tr style="border-bottom: 1px dashed #000000">
                  <td colspan="2" style="text-align: left;">
                    <div style="font-weight: bold;">Payments</div>Cash
                  </td>
                  <td colspan="3" style="text-align: right; vertical-align: bottom">1000.00</td>
                </tr>
                <tr>
                  <td colspan="5" style="text-align: center">Tax breakdown</td>
                </tr>
                <tr class="text-center" style="border-bottom: 1px dashed #000000">
                  <td class="w-25">Rate %</td>
                  <td class="w-25">Net</td>
                  <td class="w-25">Tax</td>
                  <td colspan="2" class="w-25">Total</td>
                </tr>
                <tr class="text-center" style="border-bottom: 1px dashed #000000">
                  <td class="w-25">
                    <div>0.00</div>
                    <div>VAT 16.00</div>
                  </td>
                  <td class="w-25">
                    <div>0.00</div>
                    <div>1551.72</div>
                  </td>
                  <td class="w-25">
                    <div>0.00</div>
                    <div>248.28</div>
                  </td>
                  <td colspan="2" class="w-25">
                    <div>0.00</div>
                    <div>1800.00</div>
                  </td>
                </tr>
                <tr>
                  <td colspan="5">
                    <div>Sold By: Nelly</div>
                    <div>Sold on: POS-06</div>
                  </td>
                </tr>
                <tr>
                  <td
                    colspan="5"
                    style="word-break: break-all"
                  >213942876598346598274892374987593487593489328492374</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-if="rtemp_id == 2" class="col-md-12 d-flex justify-content-center">
          <div class="receipt">
            <table>
              <thead>
                <tr>
                  <th colspan="3">
                    <div>CENTURY CINEMAX GARDEN CITY</div>
                    <div>0796 299 982 / 0789 042 901</div>
                    <div>Pin No: P051359115A</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <div style="font-weight: bold">Sales Receipt</div>
                    <div>15/02/20 13:24</div>
                  </td>
                  <td colspan="2" style="vertical-align: bottom;">Transaction No: 462999</td>
                </tr>
                <tr>
                  <td style="font-weight: bold" colspan="3">Box Office</td>
                </tr>
                <tr>
                  <td colspan="3" style="border-bottom: 1px dashed #000000; padding: 0px;"></td>
                </tr>
                <tr>
                  <td>Description</td>
                  <td>Qty</td>
                  <td>Price</td>
                </tr>
                <tr>
                  <td colspan="3" style="border-bottom: 1px dashed #000000; padding: 0px;"></td>
                </tr>
                <tr>
                  <td>Tanhaji-2D-Hindi (Screen 1: Gold) 15/02/20 02:30 Hrs</td>
                  <td>2</td>
                  <td>300</td>
                </tr>
                <tr>
                  <td colspan="3" style="font-weight: bold;">Additional Charges</td>
                </tr>
                <tr>
                  <td colspan="3" style="border-bottom: 1px dashed #000000; padding: 0px;"></td>
                </tr>
                <tr>
                  <td>Description</td>
                  <td>Rate</td>
                  <td style="white-space: nowrap;">Tax value</td>
                </tr>
                <tr>
                  <td colspan="3" style="border-bottom: 1px dashed #000000; padding: 0px;"></td>
                </tr>
                <tr>
                  <td>SGST</td>
                  <td>10%</td>
                  <td>37.98</td>
                </tr>
                <tr>
                  <td>CGST</td>
                  <td>10%</td>
                  <td>37.98</td>
                </tr>
                <tr>
                  <td>Service Charge</td>
                  <td>10%</td>
                  <td>37.98</td>
                </tr>
                <tr>
                  <td colspan="3" style="border-top: 1px solid #000000; padding: 0px;"></td>
                </tr>
                <tr>
                  <td style="text-align: left; font-weight: bold;">Total</td>
                  <td colspan="2" style="text-align: right; font-weight: bold;">1200.00</td>
                </tr>
                <tr>
                  <td colspan="3" style="border-top: 1px solid #000000; padding: 0px;"></td>
                </tr>
                <tr>
                  <td colspan="3" style="text-align: left; font-weight: bold;">
                    <span>Concessions</span>
                  </td>
                </tr>
                <tr>
                  <td colspan="3" style="border-bottom: 1px dashed #000000; padding: 0px;"></td>
                </tr>
                <tr style="text-align: left;">
                  <td>Item</td>
                  <td>Qty</td>
                  <td style="white-space: nowrap;">Net Amount</td>
                </tr>
                <tr>
                  <td colspan="3" style="border-bottom: 1px dashed #000000; padding: 0px;"></td>
                </tr>
                <tr style="text-align: left;">
                  <td>Sandwich</td>
                  <td>1</td>
                  <td>30</td>
                </tr>
                <tr>
                  <td colspan="3" style="font-weight: bold;">Additional Charges</td>
                </tr>
                <tr>
                  <td colspan="3" style="border-bottom: 1px dashed #000000; padding: 0px;"></td>
                </tr>
                <tr>
                  <td>Description</td>
                  <td>Rate</td>
                  <td>Tax value</td>
                </tr>
                <tr>
                  <td colspan="3" style="border-bottom: 1px dashed #000000; padding: 0px;"></td>
                </tr>
                <tr>
                  <td>SGST</td>
                  <td>10%</td>
                  <td>37.98</td>
                </tr>
                <tr>
                  <td>CGST</td>
                  <td>10%</td>
                  <td>37.98</td>
                </tr>

                <tr>
                  <td colspan="3" style="border-top: 1px solid #000000; padding: 0px;"></td>
                </tr>

                <tr>
                  <td style="text-align: left; font-weight: bold;">Total</td>
                  <td colspan="2" style="text-align: right; font-weight: bold;">1200.00</td>
                </tr>

                <tr>
                  <td colspan="3" style="border-top: 1px solid #000000; padding: 0px;"></td>
                </tr>

                <tr>
                  <td style="text-align: left; font-weight: bold;">Grand Total</td>
                  <td colspan="2" style="text-align: right; font-weight: bold;">2400.00</td>
                </tr>
                <tr>
                  <td colspan="3">
                    <div>Sold By: Nelly</div>
                    <div>Sold on: POS-06</div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div v-if="rtemp_id == 1" class="col-md-12 d-flex justify-content-center">
          <div class="receipt">
            <table>
              <thead>
                <tr>
                  <th colspan="5">
                    <div>CENTURY CINEMAX GARDEN CITY</div>
                    <div>0796 299 982 / 0789 042 901</div>
                    <div>Pin No: P051359115A</div>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr style="border-bottom: 1px dashed #000000">
                  <td colspan="3">
                    <div class="font-weight-bold">Sales Receipt</div>
                    <div>15/02/20 13:24</div>
                  </td>
                  <td colspan="2" style="vertical-align: bottom;">Transaction No: 462999</td>
                </tr>
                <tr style="border-bottom: 1px dashed #000000">
                  <td>Qty</td>
                  <td>Description</td>
                  <td>Price</td>
                  <td>Tax</td>
                  <td>Total</td>
                </tr>
                <tr>
                  <td colspan="5" style="font-weight: bold;">Tickets</td>
                </tr>
                <tr>
                  <td>2</td>
                  <td>Tanhaji-2D-Hindi (Screen 1: Gold) 15/02/20 02:30 Hrs</td>
                  <td>300</td>
                  <td>30.00</td>
                  <td>330</td>
                </tr>
                <tr>
                  <td style="text-align: center;" colspan="2">1 Pet Soda</td>
                  <td>300</td>
                  <td>30.00</td>
                  <td>330</td>
                </tr>
                <tr>
                  <td colspan="5" style="text-align: right">Amount Due: INR 300.00</td>
                </tr>
                <tr style="border-bottom: 1px dashed #000000">
                  <td colspan="2" style="text-align: left;">
                    <div style="font-weight: bold;">Payments</div>Cash
                  </td>
                  <td colspan="3" style="text-align: right; vertical-align: bottom">1000.00</td>
                </tr>
                <tr>
                  <td colspan="5" style="text-align: center">Tax breakdown</td>
                </tr>
                <tr class="text-center" style="border-bottom: 1px dashed #000000">
                  <td class="w-25">Rate %</td>
                  <td class="w-25">Net</td>
                  <td class="w-25">Tax</td>
                  <td colspan="2" class="w-25">Total</td>
                </tr>
                <tr class="text-center" style="border-bottom: 1px dashed #000000">
                  <td class="w-25">
                    <div>0.00</div>
                    <div>VAT 16.00</div>
                  </td>
                  <td class="w-25">
                    <div>0.00</div>
                    <div>1551.72</div>
                  </td>
                  <td class="w-25">
                    <div>0.00</div>
                    <div>248.28</div>
                  </td>
                  <td colspan="2" class="w-25">
                    <div>0.00</div>
                    <div>1800.00</div>
                  </td>
                </tr>
                <tr>
                  <td colspan="5">
                    <div>Sold By: Nelly</div>
                    <div>Sold on: POS-06</div>
                  </td>
                </tr>
                <tr>
                  <td
                    colspan="5"
                    style="word-break: break-all"
                  >213942876598346598274892374987593487593489328492374</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div> -->
  </div>
</template>


<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      rtemp_id: "",
      receipttemp_name: "",
      receipt_is_active: true,
      htmlData: null
    };
  },
  beforeMount() {
    const { rtemp_id } = this.$route.query;
    this.getTemplateListByID(rtemp_id);
  },
  methods: {
    getTemplateListByID: function (id) {
      let payload = {
        rtemp_id: id,
        flag: "View"
      };

      MasterService.GetSingleReceiptTemplate(payload)
        .then((response) => {
          const { data } = response;
          this.htmlData = data
          // if (data.status) {
          //   if (data.Records && data.Records.length > 0) {
          //     let Obj = data.Records[0];
          //     this.rtemp_id = id;
          //     this.receipttemp_name = Obj.rtemp_name;
          //     this.receipt_is_active =
          //       Obj.rtemp_is_active == "Y" ? true : false;
          //   }
          // } else {
          //   this.$toasted.show(data.message);
          // }
        })
        .catch(this._CatchError);
    },
  },
};
</script>


<style scoped>
.bl-5 {
  border-left: 3px solid #000000;
}
</style>





// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/ReceiptsTemplate/viewReceiptsTemplate.vue